module.exports = "/_next/static/images/279e9ebbe032b7c18ffd9255e1280f7e-device-frame-dark@1x.png";